module.exports = __webpack_public_path__ + "img/artboard7.79ebdb27.png";